module.exports = __webpack_public_path__ + "static/media/app6.9ac0cde5.png";